import { storeApplyInfo, getSellerInfo, storeId } from '_h/account'

export const updateMsgSocket = (vm) => {
  vm.$initSocket && vm.$initSocket('refresh')
}

export const getUsabled = (vm) => vm.$axios
  .get('/store/localized-subsidiaries/usable')
  .then((response) => {
    const localizedSubsidiaries = response.data.data.localizedSubsidiaries
    const regionList = JSON.stringify(localizedSubsidiaries)
    vm.$storage.set('regionList', regionList)
  })
  .catch((error) => {
    console.error(error)
    const err = error.response
    if (err && err.status > 500) {
      vm.$Message.error(err.status + err.statusText)
    }
    if (err && err.data.msg) {
      vm.$Message.error(err.data.msg)
    }
  })

export const sendStoreId = (vm, id) => vm.$axios.request(storeId(id)).then((res) => {
  if (res.data.code === 0) {
    vm.$SetCookieFn('user-token', res.data.data.token)
    vm.$SetCookieFn('has-store', true)
    const countries = JSON.parse(vm.$storage.get('regionList') || '[]')
    if (!countries.length) {
      getUsabled(vm)
    }
    const redirect = vm.$route?.query?.redirect
    if (redirect && redirect.indexOf('login') < 0) {
      vm.$router.push(`${redirect}`)
    } else {
      vm.$router.push('/seller-center/home')
    }
    updateMsgSocket(vm)
    vm.$cookies.remove('voucher')
  }
})

export const getStoreArea = (vm, storeIdValue) => vm.$axios
  .get('/national-stations', {
    params: {
      stationType: 3,
      storeId: storeIdValue
    }
  })
  .then((response) => {
    const countrylist = JSON.stringify(response.data.data)
    vm.$SetCookieFn('countryList', JSON.stringify(countrylist))
    return sendStoreId(vm, storeIdValue)
  })
  .catch((error) => {
    console.error(error)
    const err = error.response
    vm.spinShow = false
    if (err && err.status > 500) {
      vm.$Message.error(err.status + err.statusText)
    }
    if (err && err.data.msg) {
      vm.$Message.error(err.data.msg)
    }
  })

export const storeLogin = (vm) => {
  if (!vm.store) {
    return
  }
  const store = JSON.parse(vm.store)
  vm.$SetCookieFn('store-id', store.storeId)
  vm.$SetCookieFn('store-name', store.storeName)
  vm.$SetCookieFn('store-logo', store.storeLogo)
  vm.$SetCookieFn('storeRegion-id', store.regionId)
  return getStoreArea(vm, store.storeId)
}

export const getSellerInfoData = async (vm) => {
  try {
    const res = await getSellerInfo(vm.$axios)
    const { basicInfo, settlementInfo } = res.sellerInfo
    if (!basicInfo.idNumber) {
      vm.$router.push({
        path: '/create-seller-account/step2'
      })
      return
    }
    if (!settlementInfo.bankName && !settlementInfo.skipSettlementInfo) {
      vm.$router.push({
        path: '/create-seller-account/step3'
      })
      return
    }
    vm.$axios
      .request(storeApplyInfo({
        sellerId: vm.$cookies.get('seller-id')
      }))
      .then((response) => {
        if (Number(response.data.code) === 0) {
          const applyListLen = response.data.data.length
          let stepPath = '/create-seller-account/step5'
          if (applyListLen <= 0) {
            stepPath = settlementInfo.skipSettlementInfo
              ? '/create-seller-account/step3'
              : '/create-seller-account/step4?default=1'
          }
          vm.$router.push(stepPath)
        }
      })
  } catch (error) {
    console.error(error)
    vm.$handleError(vm, error)
  }
}

export const handleLoginSuccess = (vm, data) => {
  if (!data) {
    return
  }
  vm.$Message.success(vm.$t('login.loginSuccess'))
  vm.$SetCookieFn('user-token', data.token)
  vm.$SetCookieFn('user-account', data.account)
  vm.$SetCookieFn('user-id', data.userId)
  vm.$SetCookieFn('seller-type', data.seller?.sellerType)
  vm.$SetCookieFn('seller-id', data.seller?.sellerId)
  vm.$SetCookieFn('account-type', data.accountType)
  vm.$SetCookieFn(
    'region-id',
    data.seller?.sellerAddress?.regionId || data.seller?.sellerRegionId
  )
  vm.$SetCookieFn('sellerRegionId', data.seller?.sellerRegionId)
  vm.$SetCookieFn(
    'user-stateId',
    data.seller?.sellerAddress?.stateId
  )
  vm.$SetCookieFn(
    'user-state',
    data.seller?.sellerAddress?.state
  )
  vm.$SetCookieFn(
    'user-cityId',
    data.seller?.sellerAddress?.cityId
  )
  vm.$SetCookieFn(
    'user-city',
    data.seller?.sellerAddress?.city
  )
  data.email && vm.$SetCookieFn('account-email', data.email)
  const stores = data.stores || []
  if (stores.length === 0) {
    vm.$store.commit('setIsLogin')
    vm.$store.commit(
      'setUserName',
      vm.$cookies.get('user-account')
    )
    vm.$Message.warning(vm.$t('nav.noStore'))
    getSellerInfoData(vm)
  } else if (stores.length === 1) {
    vm.$SetCookieFn('store-id', stores[0].storeId)
    vm.$SetCookieFn('store-name', stores[0].storeName)
    vm.$SetCookieFn('store-logo', stores[0].storeLogo)
    vm.$SetCookieFn('storeRegion-id', stores[0].regionId)
    getStoreArea(vm, stores[0].storeId)
    const obj = data.permissions
    vm.$storage.set('permissions', JSON.stringify(obj))
  } else {
    vm.stores = stores
    vm.showChooseStore = true
    const obj = data.permissions
    vm.$storage.set('permissions', JSON.stringify(obj))
  }
}
